"use client";
import { create } from "zustand";

const STORAGE_KEY = "bookingData";

const loadStoredBooking = () => {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const useBookingStore = create((set) => ({
  bookingData: null,
  loading: false,
  setLoading: (loading) => set({ loading }),
  setBookingData: (bookingData) => set({ bookingData }),
  clearBookingData: () => set({ bookingData: null }),
  hydrateBooking: () => {
    const stored = loadStoredBooking();
    if (stored) set({ bookingData: stored });
  },
}));

export const persistBookingData = (data) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const clearPersistedBooking = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
};
